import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Image, Button } from "react-bootstrap";
import NoDataFound from "../NoDataFound/NoDataFound";
import VerifiedBadgeNoShadow from "../Handlers/VerifiedBadgeNoShadow";
import { translate, t } from "react-multi-lang";
import api from "../../Environment";
import "./notification.css";
import { SocketState } from '../Socket/SocketProvider'

const NotificationAllSec = (props) => {
  const { notifications } = props;
  // const { chatSocket } = SocketState()

  // useEffect(() => {
  //   if (chatSocket != null) {
  //     console.log("notification_update")
  //     chatSocket.emit("notification update", {
  //       commonid: "user_id_" + localStorage.getItem("userId"),
  //       myid: localStorage.getItem("userId"),
  //     });
  //   }

  // }, [chatSocket]);
  return (
    <>
      <div
        role="tabpanel"
        className={
          props.activeSec === "notify-all-sec"
            ? "tab-pane fade in active"
            : "tab-pane fade"
        }
        id="Section1"
      >
        <h3 className="notify-title">{t("all")}</h3>
        <div className="notification-list">
          {notifications.length > 0 ? (
            notifications.map((notification, index) => (
              <div className="notify-item" key={index}>
                <div className="post-header">
                  <div className="alignleft">
                    <a
                      className="title-container"
                      href={notification.action_url == "fans" ? notification.from_username : notification.action_url}
                      target="_blank"
                    >
                      <Image
                        src={notification.from_userpicture ? (api.serviceUrl() + '/' + notification.from_userpicture) : '/assets/images/upload-profile-img.svg'}
                        className="user-image img-responsive notification-user-img "
                      />
                      <div className="user-name box" style={{ marginRight: "10px" }}>
                        <span className="post-user-name">
                          {notification.from_displayname}{" "}
                          {notification.from_user.is_verified_badge == 1 ? (
                            <div className="pl-2">
                              <VerifiedBadgeNoShadow />
                            </div>
                          ) : null}
                          <span className="user-id">
                            <Link
                              target="_blank"
                              to={notification.from_username}
                            >
                              @{notification.from_username}
                            </Link>
                          </span>
                        </span>
                        <span className="post-user-notify">
                          {notification.message} {notification.post_id != 0 && notification?.post?.content && (<>"{notification?.post?.content}"</>)}
                        </span>
                        {/* {notification.post_id != 0 && (<div
                          className={
                            "chat-item bg-light border p-3"
                          }
                        >
                          <div>
                            <div className="chat-body">
                              <Image
                                src={notification?.post_image?.post_file ? (api.serviceUrl() + '/' + notification.post_image?.post_file) : '/assets/images/icons/post.svg'}
                                className="img-responsive notification-user-img mr-3"
                              />
                              <span className="post-user-notify">
                                {notification.post.content}
                              </span>
                            </div>
                          </div>
                        </div>)} */}

                        <span className="post-user-notify-date pt-2">
                          {notification.updated_formatted}
                        </span>
                      </div>
                      {notification.post_id != 0 && notification?.post_image?.post_file && (<Image
                        src={notification?.post_image?.file_type == "video" ? (api.serviceUrl() + '/' + notification.post_image?.preview_file) : (api.serviceUrl() + '/' + notification.post_image?.post_file)}
                        className="img-responsive notification-user-img "
                        style={{ borderRadius: 10 }}
                      />)}
                    </a>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <NoDataFound></NoDataFound>
          )}
        </div>
      </div>
    </>
  );
};

export default translate(NotificationAllSec);
